import EventsPage from '../../components/EventsPage';

export default function AdminEvents() {
  return <EventsPage isAdmin />;
}
